import { Opco } from "types/Opco";

const opcoList: Opco[] = ["es", "it", "de", "gb", "eg", "pt", "lw", "za", "ro", "cz", "tr", "gr"];

// we mainly doing that condition here because window.location.pathname can be both:
// /subscriptionplus/es
// /es

const getOpco = (): Opco => {
  const pathSplits = window.location.pathname.split("/");

  if (pathSplits[2] && opcoList.includes(pathSplits[2] as Opco)) {
    return pathSplits[2] as Opco;
  }

  return pathSplits[1] as Opco;
};

export default getOpco;
